import React from "react";
import { useParams } from "react-router-dom";
import ScoreBreakDown from "../components/ScoreBreakDown";

const ScorePage = (props) => {
  var { scoreObj } = useParams();
  var id = scoreObj;
  return (
    <div>
      <h1 id="Top">Score Breakdown</h1>
      <br />
      <ScoreBreakDown
        logo={props.logo}
        Quotes={props.Quotes}
        activeProfile={props.activeProfile}
        label={``}
        currentKey={id}
        Subscribed={props.Subscribed}
        Dev={props.Dev}
        currentProfileIdx={props.activeProfileIdx}
        UserID={props.userKey}
      />
    </div>
  );
};
export default ScorePage;
